module.exports = __webpack_public_path__ + "static/media/drum-vertical.363d7d4c.png";